// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var mentionRe = new RegExp("@([^\\s@]*)$");

var slashRe = new RegExp("^/(\\S*)(?:\\s+(.*))?$");

function trimEnd(text) {
  return text.replace(new RegExp("\\s+$"), "");
}

var slashInsertRe = (new RegExp('^/(?:add-game|add\\s+game)(?:\\s+(.*))?$', 'i'));

var navigationKeys = [
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End"
];

function isNavigationKey(key) {
  return Belt_Array.some(navigationKeys, (function (k) {
                return k === key;
              }));
}

function clampComposerHeight(scrollHeight) {
  return Math.min(scrollHeight, 128);
}

function regexCapture(captures, index) {
  var match = Belt_Array.get(captures, index);
  if (match === undefined) {
    return "";
  }
  var value = Caml_option.valFromOption(match);
  if (value !== undefined) {
    return value;
  } else {
    return "";
  }
}

function getMentionQuery(text, cursor) {
  var before = text.slice(0, cursor);
  var captures = before.match(mentionRe);
  if (captures === null) {
    return ;
  }
  var match = Belt_Array.get(captures, 1);
  if (match === undefined) {
    return ;
  }
  var query = Caml_option.valFromOption(match);
  if (query !== undefined) {
    return query;
  }
  
}

function getSlashQuery(text) {
  var captures = text.match(slashRe);
  if (captures === null) {
    return ;
  }
  var command = regexCapture(captures, 1);
  var argument = regexCapture(captures, 2).trim();
  return {
          command: command,
          argument: argument
        };
}

function buildSlashCombinedText(slashInsertText, slashArgument) {
  if (slashArgument === "") {
    return slashInsertText;
  } else {
    return trimEnd(slashInsertText) + " " + slashArgument;
  }
}

function buildMentionInsertValue(savedValue, cursor, insertText) {
  var before = savedValue.slice(0, cursor);
  var after = savedValue.slice(cursor, savedValue.length);
  var replaced = before.replace(mentionRe, "@" + insertText + " ");
  var newValue = replaced + after;
  return [
          newValue,
          replaced.length
        ];
}

function parseAddGameQuery(text) {
  var captures = text.match(slashInsertRe);
  if (captures !== null) {
    return regexCapture(captures, 1).trim();
  } else {
    return "";
  }
}

function resizeComposer(element) {
  var style = element.style;
  style.height = "auto";
  var next = Math.min(element.scrollHeight | 0, 128);
  style.height = String(next) + "px";
}

function scrollToBottom(element) {
  element.scrollTop = element.scrollHeight;
}

function assistantChatMounted() {
  var self = this ;
  scrollToBottom(self.el);
}

function assistantChatUpdated() {
  var self = this ;
  scrollToBottom(self.el);
}

function resolveTarget(self, element) {
  var value = element.getAttribute("data-phx-target");
  if (!(value == null) && value !== "") {
    return value;
  } else {
    return self._mentionTarget;
  }
}

var emptyPayload = ({});

function pushMentionQuery(self, element, target) {
  if (self._insertingMention) {
    return ;
  }
  var match = getSlashQuery(element.value);
  if (match !== undefined) {
    self._slashArgument = match.argument;
    self.pushEventTo(target, "slash_command_query", {
          query: match.command
        });
    if (self._lastHadMentionQuery) {
      self.pushEventTo(target, "mention_closed", emptyPayload);
    }
    self._lastHadMentionQuery = false;
    self._lastHadSlashQuery = true;
    return ;
  }
  if (self._lastHadSlashQuery) {
    self.pushEventTo(target, "slash_command_closed", emptyPayload);
  }
  self._lastHadSlashQuery = false;
  var value = element.selectionStart;
  var cursor = (value == null) ? element.value.length : value;
  var text = element.value;
  var query = getMentionQuery(text, cursor);
  if (query !== undefined) {
    self._lastMentionCursor = cursor;
    self._lastMentionValue = text;
    self.pushEventTo(target, "mention_query_changed", {
          query: query
        });
    self._lastHadMentionQuery = true;
  } else {
    if (self._lastHadMentionQuery) {
      self.pushEventTo(target, "mention_closed", emptyPayload);
    }
    self._lastHadMentionQuery = false;
  }
}

function assistantChatInputMounted() {
  var self = this ;
  var element = self.el;
  var value = element.getAttribute("data-phx-target");
  var target = !(value == null) && value !== "" ? value : element;
  self._mentionTarget = target;
  self._lastMentionCursor = 0;
  self._lastMentionValue = "";
  self._insertingMention = false;
  self._slashArgument = "";
  self._lastHadMentionQuery = false;
  self._lastHadSlashQuery = false;
  var onKeydown = function ($$event) {
    if ($$event.key === "Enter" && !$$event.shiftKey) {
      $$event.preventDefault();
      var form = element.closest("form");
      if (!(form == null)) {
        form.dispatchEvent(new Event("submit", {
                  bubbles: true,
                  cancelable: true
                }));
      }
      
    }
    if ($$event.key === "Escape") {
      self._slashArgument = "";
      if (self._lastHadMentionQuery) {
        self.pushEventTo(target, "mention_closed", emptyPayload);
        self._lastHadMentionQuery = false;
      }
      if (self._lastHadSlashQuery) {
        self.pushEventTo(target, "slash_command_closed", emptyPayload);
        self._lastHadSlashQuery = false;
        return ;
      } else {
        return ;
      }
    }
    
  };
  var onInput = function (param) {
    resizeComposer(element);
    pushMentionQuery(self, element, target);
  };
  var onKeyup = function ($$event) {
    if (isNavigationKey($$event.key)) {
      return pushMentionQuery(self, element, target);
    }
    
  };
  var onClick = function (param) {
    pushMentionQuery(self, element, target);
  };
  var onSlashCommandClick = function ($$event) {
    var match = element.closest("#home-ask-hero");
    if (match == null) {
      return ;
    }
    var node = $$event.target;
    if (node == null) {
      return ;
    }
    var btn = node.closest("button[phx-click=\"slash_command_select\"]");
    if (btn == null) {
      return ;
    }
    if (DomEl$GameDataCore.attr(btn, "phx-value-command") !== "add-game") {
      return ;
    }
    $$event.preventDefault();
    $$event.stopPropagation();
    var query = parseAddGameQuery(element.value);
    self.pushEventTo(target, "slash_command_select", {
          command: "add-game",
          fill_text: "",
          query: query
        });
  };
  var root = element.closest("#home-ask-returning");
  var slashRoot = !(root == null) && DomEl$GameDataCore.isHtmlElement(root) ? Caml_option.some(root) : undefined;
  var keydownOff = DomEl$GameDataCore.on(element, "keydown", onKeydown);
  var inputOff = DomEl$GameDataCore.on(element, "input", onInput);
  var keyupOff = DomEl$GameDataCore.on(element, "keyup", onKeyup);
  var clickOff = DomEl$GameDataCore.on(element, "click", onClick);
  var slashRootOff = slashRoot !== undefined ? DomEl$GameDataCore.onWithOptions(Caml_option.valFromOption(slashRoot), "click", onSlashCommandClick, {
          capture: true
        }) : undefined;
  self._handlers = {
    keydownOff: keydownOff,
    inputOff: inputOff,
    keyupOff: keyupOff,
    clickOff: clickOff,
    slashRootOff: slashRootOff
  };
  self._slashRoot = slashRoot;
}

function assistantChatInputDestroyed() {
  var self = this ;
  var h = self._handlers;
  if (h === undefined) {
    return ;
  }
  h.keydownOff();
  h.inputOff();
  h.keyupOff();
  h.clickOff();
  var off = h.slashRootOff;
  if (off !== undefined) {
    off();
  }
  self._handlers = undefined;
  self._slashRoot = undefined;
}

function assistantChatInputUpdated() {
  var self = this ;
  var element = self.el;
  var target = resolveTarget(self, element);
  if (DomEl$GameDataCore.data(element, "composer-reset") === "true") {
    element.value = "";
    self._slashArgument = "";
    resizeComposer(element);
    self.pushEventTo(target, "composer_reset_consumed", emptyPayload);
    return ;
  }
  var slashInsertText = DomEl$GameDataCore.data(element, "slash-insert-text");
  if (slashInsertText !== "") {
    var combined = buildSlashCombinedText(slashInsertText, self._slashArgument);
    self._slashArgument = "";
    element.focus();
    element.value = combined;
    element.setSelectionRange(combined.length, combined.length);
    resizeComposer(element);
    element.dispatchEvent(new Event("input", {
              bubbles: true,
              cancelable: false
            }));
    self.pushEventTo(target, "slash_command_insert_consumed", emptyPayload);
    return ;
  }
  var insertText = DomEl$GameDataCore.data(element, "insert-text");
  if (insertText === "") {
    return ;
  }
  var savedValue = self._lastMentionValue !== "" ? self._lastMentionValue : element.value;
  var cursor = self._lastMentionCursor > 0 ? self._lastMentionCursor : savedValue.length;
  var match = buildMentionInsertValue(savedValue, cursor, insertText);
  var newCursor = match[1];
  element.focus();
  element.value = match[0];
  element.setSelectionRange(newCursor, newCursor);
  resizeComposer(element);
  self._insertingMention = true;
  element.dispatchEvent(new Event("input", {
            bubbles: true,
            cancelable: false
          }));
  self._insertingMention = false;
  self.pushEventTo(target, "mention_insert_consumed", emptyPayload);
}

var assistantChat = {
  mounted: assistantChatMounted,
  updated: assistantChatUpdated
};

var assistantChatInput = {
  mounted: assistantChatInputMounted,
  destroyed: assistantChatInputDestroyed,
  updated: assistantChatInputUpdated
};

var maxComposerHeightPx = 128;

export {
  maxComposerHeightPx ,
  mentionRe ,
  slashRe ,
  trimEnd ,
  slashInsertRe ,
  navigationKeys ,
  isNavigationKey ,
  clampComposerHeight ,
  regexCapture ,
  getMentionQuery ,
  getSlashQuery ,
  buildSlashCombinedText ,
  buildMentionInsertValue ,
  parseAddGameQuery ,
  resizeComposer ,
  scrollToBottom ,
  assistantChatMounted ,
  assistantChatUpdated ,
  resolveTarget ,
  emptyPayload ,
  pushMentionQuery ,
  assistantChatInputMounted ,
  assistantChatInputDestroyed ,
  assistantChatInputUpdated ,
  assistantChat ,
  assistantChatInput ,
}
/* mentionRe Not a pure module */
